import { useStores } from "hooks/useStores";
import { observer } from "mobx-react-lite";
import { UserRole } from "models/user";
import { Navigate } from "react-router-dom";

interface Props {
  roles?: UserRole[];
}

export const ProtectedRoute: React.FC<Props> = observer(
  ({ roles, children }) => {
    const { userStore } = useStores();

    if (!userStore.user) {
      return <Navigate to="/auth" replace />;
    }

    if (!roles?.includes(userStore.user?.role as UserRole)) {
      return <Navigate to="/404" />;
    }

    return <>{children}</>;
  }
);
